import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-4">黑料不打</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              专注收录真实用户评价与行业口碑的聚合平台，拒绝虚假黑料与恶意攻击，只呈现经过核实的客观信息。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/tech" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/tech" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">科技数码</Link>
              <Link to="/category/food" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">食品饮料</Link>
              <Link to="/category/finance" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">金融理财</Link>
              <Link to="/category/education" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">教育培训</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：contact@heilao-buda.com</span>
              <span>微信：heilao-buda</span>
              <span>地址：北京市朝阳区</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 黑料不打. 本站内容仅供消费者参考，不构成任何消费建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}